let productSlides = document.querySelectorAll(
  '#vertical-slider .image-panel .product-image-slide'
);
let slideHeight = productSlides.item(0).offsetHeight;

let activeSlide;

// Calculate which slide is active initially
let distToFirstSlide =
  window.scrollY + productSlides.item(0).getBoundingClientRect().top;
if (window.scrollY <= distToFirstSlide + slideHeight / 2) {
  activeSlide = 0;
} else {
  activeSlide = Math.floor(
    (window.scrollY - distToFirstSlide) / (slideHeight / 2)
  );
}

let distToActiveSlide =
  window.scrollY + productSlides.item(activeSlide).getBoundingClientRect().top;

// On resize re-calculate distances
window.addEventListener(
  'resize',
  () => {
    slideHeight = productSlides.item(0).offsetHeight;

    distToActiveSlide =
      window.scrollY +
      productSlides.item(activeSlide).getBoundingClientRect().top;
  },
  true
);

document.addEventListener('scroll', (event) => {
  // Switch active product slide up or down so
  // we know which color to use, text to use, and slide dot to be on
  if (
    window.scrollY - distToActiveSlide >= slideHeight / 2 &&
    activeSlide < productSlides.length - 1
  ) {
    activeSlide += 1;
    distToActiveSlide =
      window.scrollY +
      productSlides.item(activeSlide).getBoundingClientRect().top;

    changeSlide(activeSlide);
  } else if (
    distToActiveSlide - window.scrollY >= slideHeight / 2 &&
    activeSlide >= 1
  ) {
    activeSlide -= 1;
    distToActiveSlide =
      window.scrollY +
      productSlides.item(activeSlide).getBoundingClientRect().top;

    changeSlide(activeSlide);
  }
});

function changeSlide(activeSlide) {
  let productInfoTabs = document.querySelectorAll(
    '#vertical-slider .info-panel .product-info'
  );

  // Change the active product info
  productInfoTabs.forEach((el, index) => {
    if (index == activeSlide) {
      setTimeout(() => {
        el.style.display = 'flex';
        setTimeout(() => {
          el.style.opacity = '1';
        }, 10);
      }, 500);
    } else if (el.style.display == 'flex') {
      el.style.opacity = '0';
      setTimeout(() => {
        el.style.display = 'none';
      }, 500);
    }
  });

  document
    .querySelectorAll('#vertical-slider .info-panel .nav-dots-wrapper .nav-dot')
    .forEach((el, index) => {
      if (index == activeSlide) {
        el.classList.add('active');
      } else {
        el.classList.remove('active');
      }
    });
}

// Add delay to fix double showing issue
setTimeout(() => {
  changeSlide(activeSlide);
}, 100);